/**
 * Calculates the student loan repayment based on the user's gross salary.
 *
 * @param {number} slQualifyingSalary - The user's annual gross salary (student loan repayments are calculated based on your gross income)
 * @param {string} plan - The student loan plan ("plan1", "plan2", "plan4", "postgraduate", or "none").
 * @param {string} configYear - The configuration year.
 * @returns {number} - The annual student loan repayment.
 */
export const calculateStudentLoanRepayment = (slQualifyingSalary, plan, config) => {
    if (!plan || plan.toLowerCase() === 'none') return 0;
    
    // Safety check for config
    if (!config || !config.STUDENT_LOANS) {
        return 0;
    }
    
    const loanConfig = config.STUDENT_LOANS[plan.toLowerCase()];
    
    if (!loanConfig) return 0;
    
    const { threshold, rate } = loanConfig;
    if (slQualifyingSalary <= threshold) return 0;
    
    // Calculate the repayment on the amount above the threshold.
    // The rate is a percentage, so we divide by 100.
    const repayment = (slQualifyingSalary - threshold) * (rate / 100);
    
    return repayment;
  };